import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import Dialog from "material-ui/Dialog";
import { assignOrganizationToTeamMember, unassignOrganizationFromTeamMember, activateTeamMember, deactivateTeamMember, getAllClients, getPartnerDetailsByPartnerOrgId, getTeamMemberDetails, selectItem, deselectItem, resendInvite, revokeUserInvite, toggleAllSelected } from "redux/modules/teamManagement";
import Helmet from "react-helmet";
import Checkbox from "material-ui/Checkbox";
import RaisedButton from "material-ui/RaisedButton";
import { ListItem } from "material-ui/List";
import moment from "moment";
import { LeftNavLayout } from "containers";
import { ModalTopBar, PageHeader, QueueFlyoutTab, WarningButton, SelectableList, Snackbar, Spinner, CheckboxList, Control, ControlBar } from "components";
import * as _ from "lodash";
import * as styles from "./TeamMemberDetail.scss";
var TeamMemberDetail = (_dec = connect(function (state) {
  return {
    allClients: state.teamManagement.allClients,
    isAssigning: state.teamManagement.isAssigning,
    isUnassigning: state.teamManagement.isUnassigning,
    selectedAssignedClients: state.teamManagement.selectedAssignedClients,
    selectedUnassignedClients: state.teamManagement.selectedUnassignedClients,
    organization: state.organization.current,
    whiteLabelOrgId: state.theme.org,
    selectedFields: state.teamManagement.selectedClientTableColumns,
    teamMemberDetail: state.teamManagement.teamMemberDetail,
    theme: state.theme,
    isPending: state.teamManagement.teamMemberDetail && state.teamManagement.teamMemberDetail.orgStatus === "PENDING",
    partnerDetails: state.teamManagement.partnerDetails
  };
}, {
  assignOrganizationToTeamMember: assignOrganizationToTeamMember,
  unassignOrganizationFromTeamMember: unassignOrganizationFromTeamMember,
  activateTeamMember: activateTeamMember,
  deactivateTeamMember: deactivateTeamMember,
  getAllClients: getAllClients,
  getPartnerDetailsByPartnerOrgId: getPartnerDetailsByPartnerOrgId,
  getTeamMemberDetails: getTeamMemberDetails,
  selectItem: selectItem,
  deselectItem: deselectItem,
  resendInvite: resendInvite,
  revokeUserInvite: revokeUserInvite,
  toggleAllSelected: toggleAllSelected
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TeamMemberDetail, _Component);

  var _super = _createSuper(TeamMemberDetail);

  function TeamMemberDetail(props) {
    var _this;

    _classCallCheck(this, TeamMemberDetail);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleAssign", function () {
      _this.props.assignOrganizationToTeamMember(_this.props.selectedUnassignedClients, _this.props.teamMemberDetail.id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUnassign", function () {
      _this.props.unassignOrganizationFromTeamMember(_this.props.selectedAssignedClients, _this.props.teamMemberDetail.id);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function () {
      if (_this.state.selectedTab === 0) {
        _this.props.toggleAllSelected(_this.props.teamMemberDetail.assignedClients.map(function (c) {
          return c.id;
        }), "selectedAssignedClients");
      } else if (_this.state.selectedTab === 1) {
        var formattedAllClients = _this.props.allClients.map(function (c, index) {
          c.id = c.organization_id;
          return c;
        });

        var filteredClientList = [];
        formattedAllClients.forEach(function (c) {
          var clientAlreadyAssigned = false;

          _this.props.teamMemberDetail.assignedClients.forEach(function (ac) {
            if (ac.id === c.id) {
              clientAlreadyAssigned = true;
            }
          });

          if (!clientAlreadyAssigned) {
            filteredClientList.push(c);
          }
        });

        _this.props.toggleAllSelected(filteredClientList.map(function (c) {
          return c.id;
        }), "selectedUnassignedClients");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleRowClick", function (selectedRow) {
      var clickedId;

      if (_this.state.selectedTab === 0) {
        clickedId = _this.props.teamMemberDetail.assignedClients[selectedRow].id;
      } else if (_this.state.selectedTab === 1) {
        var formattedAllClients = _this.props.allClients.map(function (c, index) {
          c.name = c.organization_name;
          c.id = c.organization_id;
          return c;
        });

        var filteredClientList = [];
        formattedAllClients.forEach(function (c) {
          var clientAlreadyAssigned = false;

          _this.props.teamMemberDetail.assignedClients.forEach(function (ac) {
            if (ac.id === c.id) {
              clientAlreadyAssigned = true;
            }
          });

          if (!clientAlreadyAssigned) {
            filteredClientList.push(c);
          }
        });
        clickedId = filteredClientList[selectedRow].id;
      }

      browserHistory.push({
        pathname: "/global/clients/".concat(clickedId)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalClose", function () {
      _this.setState({
        showRemoveConfirmModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (key) {
      _this.setState({
        selectedTab: key
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleReactivate", function () {
      _this.props.activateTeamMember(_this.props.teamMemberDetail.id, _this.props.organization.id);

      browserHistory.push({
        pathname: "/global/team"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResendInvite", function () {
      _this.props.resendInvite(_this.props.whiteLabelOrgId, _this.props.teamMemberDetail.id).then(function () {
        _this.setState({
          showSnackbar: true,
          snackbarMessage: "Invitation successfully re-sent"
        });
      })["catch"](function (err) {
        console.error(err);

        _this.setState({
          showSnackbar: true,
          snackbarMessage: "A problem occurred, please try again later."
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRevokeInvite", function () {
      _this.props.revokeUserInvite(_this.props.teamMemberDetail.id, _this.props.whiteLabelOrgId).then(function () {
        _this.setState({
          showSnackbar: true,
          snackbarMessage: "Invitation Revoked"
        });
      })["catch"](function (err) {
        console.error(err);

        _this.setState({
          showSnackbar: true,
          snackbarMessage: "A problem occurred, please try again later."
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveBtnClick", function () {
      _this.setState({
        removeInProgress: true
      });

      _this.props.deactivateTeamMember(_this.props.teamMemberDetail.id, _this.props.theme.org);

      browserHistory.push({
        pathname: "/global/team"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderBottomContent", function (details) {
      if (!details) return null;

      if (_this.state.selectedTab === 0) {
        if (details.assignedClients) {
          var filteredAssignedClients = details.assignedClients.filter(function (client) {
            return client.status !== "cancelled";
          });
          return /*#__PURE__*/React.createElement("div", {
            className: styles.bottomContentWrap
          }, filteredAssignedClients.length > 0 && /*#__PURE__*/React.createElement(CheckboxList, {
            listItems: filteredAssignedClients,
            checked: _this.props.selectedAssignedClients,
            onCheck: function onCheck(id) {
              return _this.props.selectItem(id, "selectedAssignedClients");
            },
            onUncheck: function onUncheck(id) {
              return _this.props.deselectItem(id, "selectedAssignedClients");
            },
            onRowClick: _this.handleRowClick
          }));
        }
      } else if (_this.state.selectedTab === 1) {
        var unassignedClients = _this.props.allClients.filter(function (c) {
          if (c.status === "cancelled") {
            return false;
          }

          var isAssigned = false;
          details.assignedClients.forEach(function (ac) {
            if (parseInt(ac.id) === parseInt(c.id)) {
              isAssigned = true;
            }
          });

          if (!isAssigned) {
            return true;
          }
        });

        if (_this.props.allClients) {
          var filteredClientList = [];

          _this.props.allClients.forEach(function (c) {
            var clientAlreadyAssigned = false;
            details.assignedClients.forEach(function (ac) {
              if (ac.id === c.id) {
                clientAlreadyAssigned = true;
              }
            });

            if (!clientAlreadyAssigned) {
              filteredClientList.push(c);
            }
          });

          return /*#__PURE__*/React.createElement("div", {
            className: styles.bottomContentWrap
          }, /*#__PURE__*/React.createElement(CheckboxList, {
            listItems: unassignedClients,
            checked: _this.props.selectedUnassignedClients,
            onCheck: function onCheck(id) {
              return _this.props.selectItem(id, "selectedUnassignedClients");
            },
            onUncheck: function onUncheck(id) {
              return _this.props.deselectItem(id, "selectedUnassignedClients");
            },
            onRowClick: _this.handleRowClick
          }));
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamMemberDetails", function (details) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.topWrap
      }, details.avatarUrl && /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(".concat(details.avatarUrl, ")")
        },
        className: styles.avatar
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.nameWrap,
        style: details.avatarUrl ? {
          marginLeft: 16,
          marginTop: 16
        } : {}
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: details.name,
        style: {
          marginBottom: 8
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.belowName
      }, details.email)), /*#__PURE__*/React.createElement("div", {
        className: styles.topWrapRight
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rightText
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: "bold"
        }
      }, "Join Date: "), /*#__PURE__*/React.createElement("span", null, moment(details.joinDate).format("MMM D, YYYY"))), _this.props.isPending ? /*#__PURE__*/React.createElement("div", {
        className: styles.rightButtonGroup
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.rightButton
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Re-send Invitation",
        onClick: _this.handleResendInvite
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.rightButton
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel Invitation",
        onClick: _this.handleRevokeInvite
      }))) : "", _this.props.partnerDetails && details.orgStatus === "INACTIVE" && _this.props.partnerDetails.totals.teamMembersRemaining > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.rightButton
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Reactivate",
        onClick: _this.handleReactivate
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderBottomSection", function (details) {
      var _this$props$partnerDe, _this$props$partnerDe2;

      return /*#__PURE__*/React.createElement("div", {
        className: "container-fluid",
        style: {
          paddingTop: 16
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.tabWrap
      }, /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 0,
        label: "Assigned Clients",
        key: 0,
        onClick: _this.handleTabClick.bind(_assertThisInitialized(_this), 0),
        style: {
          padding: "5px 16px"
        }
      }), /*#__PURE__*/React.createElement(QueueFlyoutTab, {
        isSelected: _this.state.selectedTab === 1,
        label: "Other Clients",
        key: 1,
        onClick: _this.handleTabClick.bind(_assertThisInitialized(_this), 1),
        style: {
          padding: "5px 16px"
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.bottomWrap
      }, _this.state.selectedTab === 1 || _this.state.selectedTab === 0 && details.assignedClients && details.assignedClients.length > 0 ? /*#__PURE__*/React.createElement("div", null, _this.state.selectedTab === 0 ? /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Unassign",
        onClick: _this.handleUnassign,
        disabled: _this.props.isUnassigning || !_this.props.selectedAssignedClients || !_this.props.selectedAssignedClients.length
      }) : null, _this.state.selectedTab === 1 ? /*#__PURE__*/React.createElement(RaisedButton, {
        label: "Assign",
        onClick: _this.handleAssign,
        disabled: _this.props.isAssigning || !_this.props.selectedUnassignedClients || !_this.props.selectedUnassignedClients.length
      }) : null) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, "No Assigned Clients"), /*#__PURE__*/React.createElement("p", null, "This team member hasn't been assigned any clients. Click \"Other Clients\" to assign some!")), _this.renderBottomContent(details), details.orgStatus !== "INACTIVE" && _this.props.partnerDetails && parseInt(_this.props.params.teamMemberId) !== parseInt((_this$props$partnerDe = _this.props.partnerDetails) === null || _this$props$partnerDe === void 0 ? void 0 : (_this$props$partnerDe2 = _this$props$partnerDe.contract) === null || _this$props$partnerDe2 === void 0 ? void 0 : _this$props$partnerDe2.ownerUserId) && /*#__PURE__*/React.createElement("div", {
        className: styles.removeWrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.removeHeader
      }, "Remove ", details.name), /*#__PURE__*/React.createElement("p", {
        className: styles.removeText
      }, "This will remove ", details.name, " from your team."), /*#__PURE__*/React.createElement(WarningButton, {
        label: "Remove ".concat(details.name.split(" ")[0]),
        onClick: function onClick() {
          return _this.setState({
            showRemoveConfirmModal: true
          });
        }
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderModal", function (details) {
      var modalBodyContent = null;

      if (_this.state.showRemoveConfirmModal) {
        modalBodyContent = /*#__PURE__*/React.createElement("div", {
          className: styles.modalBodyContent
        }, /*#__PURE__*/React.createElement("p", null, "You are about to remove ", details.name, " from your team."));
      }

      var modalActions = !_this.state.removeInProgress ? [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        onClick: _this.handleModalClose,
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(WarningButton, {
        label: "Remove",
        onClick: _this.handleRemoveBtnClick
      })] : [/*#__PURE__*/React.createElement(RaisedButton, {
        label: "Cancel",
        style: {
          marginRight: 12
        }
      }), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Remove",
        disabled: true
      })];
      return /*#__PURE__*/React.createElement(Dialog, {
        actionsContainerStyle: {
          borderTop: 0,
          padding: "5px 20px 20px 20px"
        },
        title: "Are You Sure?",
        titleStyle: {
          color: _this.props.theme.colors.primaryColor
        },
        actions: modalActions,
        autoScrollBodyContent: true,
        modal: true,
        open: _this.state.showRemoveConfirmModal,
        onRequestClose: _this.handleModalClose,
        bodyStyle: {
          color: "#717171",
          lineHeight: "24px"
        }
      }, modalBodyContent);
    });

    _this.state = {
      selectedTab: 0,
      showSnackbar: false,
      snackbarMessage: "",
      showRemoveConfirmModal: false,
      removeInProgress: false
    };
    return _this;
  }

  _createClass(TeamMemberDetail, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.getAllClients({
        orgTypeId: "".concat(this.props.theme.org) === "0" ? 3 : null,
        parentOrganizationId: this.props.theme.org
      });
      this.props.getTeamMemberDetails(this.props.params.teamMemberId);
      this.props.getPartnerDetailsByPartnerOrgId(this.props.theme.org);
    }
  }, {
    key: "render",
    value: function render() {
      var details = this.props.teamMemberDetail.hasOwnProperty("id") ? this.props.teamMemberDetail : false;
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: "1 1 auto",
          paddingBottom: "36px"
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Team Member Detail"
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        backUrl: "/global/team",
        showCloseBtn: false,
        style: {
          position: "static",
          marginBottom: 24
        },
        backLabel: "View All Team Members"
      }), details ? this.renderTeamMemberDetails(details) : /*#__PURE__*/React.createElement("div", {
        style: {
          height: 100,
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), details && this.renderModal(details), details && this.renderBottomSection(details), /*#__PURE__*/React.createElement(Snackbar, {
        message: this.state.snackbarMessage,
        open: this.state.showSnackbar,
        autoHideDuration: 4000
      }));
    }
  }]);

  return TeamMemberDetail;
}(Component), _defineProperty(_class2, "propTypes", {
  name: PropTypes.string,
  email: PropTypes.string,
  joinDate: PropTypes.any,
  allClients: PropTypes.array,
  assignedClients: PropTypes.array,
  selectedAssignedClients: PropTypes.array,
  selectedUnassignedClients: PropTypes.array,
  deselectItem: PropTypes.func,
  selectItem: PropTypes.func
}), _temp)) || _class);
export default TeamMemberDetail;